import { apiCall } from '../helpers/axios';

const ENDPOINT = 'emaillogs';

const getContent = async (id) => {
    try {
        const response = await apiCall().get(`${ENDPOINT}/${id}/content`);

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

const getAttachment = async (id) => {
    try {
        const response = await apiCall().get(`${ENDPOINT}/${id}/attachment`, { responseType: 'blob' });

        return response.data;
    }
    catch (error) {
        throw error.response.data;
    }
}

export default {
    getContent,
    getAttachment,
}


// WEBPACK FOOTER //
// ./src/services/email-log-service.js